// src/pages/Folder/Feeling.tsx

import { Box, Collapse } from '@mui/material'

import { FolderId, SensorRecord, SensorType } from '@/types/domain'

import { SORT } from '../../api'
import { FeelingRoom, PackageUpgrade } from '../../components'
import { useFeelingSensors } from '../../hooks'

type FeelingProps = {
  id: FolderId
}

export const Feeling = ({ id }: FeelingProps) => {
  const fSensors: SensorRecord[] = useFeelingSensors(id)
  const sTypes: SensorType[] = [
    ...new Set(fSensors.map(sensor => sensor.name)),
  ].sort(SORT)
  const upgradeAvailable: boolean = fSensors.length === 0

  return (
    <Collapse in={true}>
      <Collapse in={upgradeAvailable}>
        <PackageUpgrade id={id} />
      </Collapse>

      <Box
        display={'grid'}
        gap={3}
        gridTemplateColumns={{
          xs: '1fr',
          sm: 'repeat(1, 1fr)',
          md: 'repeat(2, 1fr)',
          lg: 'repeat(3, 1fr)',
          xl: 'repeat(4, 1fr)',
        }}
      >
        {sTypes.map((type: SensorType) => (
          <FeelingRoom id={id} key={type} type={type} />
        ))}
      </Box>
    </Collapse>
  )
}
